<template>
  <simple-pagination
    v-if="numberOfPages > 1"
    :currentpage="currentPage"
    :pages="numberOfPages"
    @changePage="onPageNumberChange"
    class="text-center"
  />
</template>

<script>
  import SimplePagination from '@/components/shared/SimplePagination';

  export default {
    components: {
      SimplePagination,
    },
    props: {
      currentPage: {type: Number, required: true},
      totalItems: {type: Number, required: true},
      itemsOnPage: {type: Number, required: true},
      onPageNumberChange: {type: Function, required: true},
    },
    computed: {
      numberOfPages() {
        return Math.ceil(this.totalItems / this.itemsOnPage);
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/Pagination.vue